import React from 'react';
import { NavLink } from 'react-router-dom';
import { IITH } from '@/pages/landing/iithBrand';

/** Horizontal menu from a fixed item list (reception / doctor / pharmacy). */
export default function CampusMenu({ items = [], accent = IITH.saffron }) {
  if (!items.length) return null;
  return (
    <nav
      className="sticky top-14 z-20 flex flex-wrap gap-1 px-4 sm:px-8 py-2.5 bg-white/95 backdrop-blur border-b border-[#D5DEE8] shadow-sm"
      data-testid="campus-menu"
      aria-label="Hospital screens"
    >
      <div className="max-w-[1500px] w-full mx-auto flex flex-wrap gap-1">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={Boolean(item.end)}
            data-testid={item.testid}
            className={({ isActive }) =>
              `px-3 py-1.5 rounded-md text-xs font-semibold transition ${
                isActive ? 'text-white shadow-sm' : 'text-[#071B34] hover:bg-[#E8EEF5]'
              }`
            }
            style={({ isActive }) => (isActive ? { background: accent } : undefined)}
          >
            {item.label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
